import { METHOD_START_MESSAGE } from '../common/constants';
import { getCallingBackEnd } from '../common/Utils';
import SDKConnector from '../SDKConnector';
import log from '../Logger';
import { CALLING_BACKEND } from '../common/types';
import { WxCallBackendConnector } from './WxCallBackendConnector';
import { CALL_SETTINGS_FILE, METHODS } from './constants';
import { UcmBackendConnector } from './UcmBackendConnector';
export class CallSettings {
    sdkConnector;
    webex;
    callingBackend;
    backendConnector;
    constructor(webex, logger, useProdWebexApis) {
        this.sdkConnector = SDKConnector;
        if (!this.sdkConnector.getWebex()) {
            SDKConnector.setWebex(webex);
        }
        log.setLogger(logger.level, CALL_SETTINGS_FILE);
        this.webex = this.sdkConnector.getWebex();
        this.initializeBackendConnector(logger, useProdWebexApis);
    }
    initializeBackendConnector(logger, useProdWebexApis) {
        this.callingBackend = getCallingBackEnd(this.webex);
        log.info(`${METHOD_START_MESSAGE} with ${this.callingBackend} backend`, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.INITIALIZE_BACKEND_CONNECTOR,
        });
        switch (this.callingBackend) {
            case CALLING_BACKEND.BWRKS:
            case CALLING_BACKEND.WXC:
                this.backendConnector = new WxCallBackendConnector(this.webex, logger);
                break;
            case CALLING_BACKEND.UCM:
                this.backendConnector = new UcmBackendConnector(this.webex, logger, useProdWebexApis);
                break;
            default:
                throw new Error('Calling backend is not identified, exiting....');
        }
    }
    async getCallWaitingSetting() {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.GET_CALL_WAITING_SETTING,
        });
        return this.backendConnector.getCallWaitingSetting();
    }
    async getDoNotDisturbSetting() {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.GET_DO_NOT_DISTURB_SETTING,
        });
        return this.backendConnector.getDoNotDisturbSetting();
    }
    async setDoNotDisturbSetting(enabled) {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.SET_DO_NOT_DISTURB_SETTING,
        });
        return this.backendConnector.setDoNotDisturbSetting(enabled);
    }
    async getCallForwardSetting() {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.GET_CALL_FORWARD_SETTING,
        });
        return this.backendConnector.getCallForwardSetting();
    }
    async setCallForwardSetting(callForwardingRequest) {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.SET_CALL_FORWARD_SETTING,
        });
        return this.backendConnector.setCallForwardSetting(callForwardingRequest);
    }
    async getVoicemailSetting() {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.GET_VOICEMAIL_SETTING,
        });
        return this.backendConnector.getVoicemailSetting();
    }
    async setVoicemailSetting(voicemailRequest) {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.SET_VOICEMAIL_SETTING,
        });
        return this.backendConnector.setVoicemailSetting(voicemailRequest);
    }
    async getCallForwardAlwaysSetting(directoryNumber) {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_SETTINGS_FILE,
            method: METHODS.GET_CALL_FORWARD_ALWAYS_SETTING,
        });
        return this.backendConnector.getCallForwardAlwaysSetting(directoryNumber);
    }
}
export const createCallSettingsClient = (webex, logger, useProdWebexApis) => new CallSettings(webex, logger, useProdWebexApis);
